module.exports = __webpack_public_path__ + "static/media/card-money.f7e7f6f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/shopping-cart/card-money.png
// module id = 2318
// module chunks = 0